import * as React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import MyProfile from './MyProfile';
// import MyAccounts from "./MyAccounts";
import { MANAGE_PROFILE /*, MY_ACCOUNTS */ } from '../../../constants/routes';
import { PageNotFound } from '../../common/noMatchPage';

const Router = () => (
    <Switch>
        <Route exact path={MANAGE_PROFILE} component={MyProfile} />
        {/* <Route exact path={MY_ACCOUNTS} component={MyAccounts} /> */}
        <Redirect to={PageNotFound} />
    </Switch>
);

export default Router;
